import React, { useEffect } from 'react';
import { observer } from 'mobx-react';
import { useHistory } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthProvider';
import appStore from '../../store/App';
import Auth from '../../store/Auth';
import ErrorBoundary from '../ErrorBoundary';
import loader from './assets/loader.gif';
import styles from './styles.module.scss';

type Props = {
  children: React.ReactNode;
};

const AuthRequired: React.FC<Props> = observer(({ children }) => {
  const { isAuthenticated, isInitialized } = useAuth();
  const history = useHistory();

  // Используем useEffect для навигации чтобы избежать state transition во время рендера
  useEffect(() => {
    if (isInitialized && !isAuthenticated) {
      history.push('/login');
    }
  }, [isInitialized, isAuthenticated, history]);

  // Дополнительная проверка консистентности с глобальным Auth
  useEffect(() => {
    if (Auth.isInitialized && !Auth.isAuthenticated && isAuthenticated) {
      console.warn('Auth state inconsistency detected, redirecting to login');
      Auth.clearAuth();
      history.push('/login');
    }
  }, [Auth.isAuthenticated, isAuthenticated, history]);

  // Показываем загрузчик пока идет инициализация
  if (!isInitialized) {
    return (
      <div className={styles.loaderContainer}>
        <img src={loader} alt="GameBoost42" />
      </div>
    );
  }

  // Если пользователь не авторизован, показываем загрузчик пока происходит редирект
  if (!isAuthenticated) {
    return (
      <div className={styles.loaderContainer}>
        <img src={loader} alt="GameBoost42" />
      </div>
    );
  }

  // Показываем загрузчик пока не загружена основная информация
  // ИЛИ если есть несоответствие в состоянии авторизации
  if (
    !appStore.isLoadedMainInfo ||
    (!Auth.isAuthenticated && Auth.isInitialized)
  ) {
    return (
      <div className={styles.loaderContainer}>
        <img src={loader} alt="GameBoost42" />
      </div>
    );
  }

  return (
    <ErrorBoundary>
      <div>{children}</div>
    </ErrorBoundary>
  );
});

export default AuthRequired;
